module.exports = __webpack_public_path__ + "static/media/02-text.94a6912b.png";